import { register } from "@rill/loader";
import { isAfterTwoDays } from "../utils/date-helpers";

register(
  {
    name: "workoutNote",
    meta: ["no-bust", "workout-notes"],
    refresh: true,
    ttl: "2 hours",
  },
  async ({ api, locals }, date, athlete, type) => {
    let user = athlete;
    if (!user) {
      user = locals.activeUser._id;
    }

    // Coaches complaining about notes in the future
    if (isAfterTwoDays(date)) return {};

    const res = await api("workout-note", {
      query: {
        user,
        date,
        type: type || "calendar",
      },
    });

    return await res.json();
  }
);

register(
  {
    name: "workoutNotes",
    meta: ["no-bust", "workout-notes"],
    refresh: true,
    ttl: "2 hours",
  },
  async ({ api, locals }, user, dateFrom, dateTo) => {
    const res = await api("workout-notes", {
      query: {
        user,
        dateFrom,
        dateTo,
      },
    });

    return await res.json();
  }
);

register(
  {
    name: "workoutCoachNote",
    meta: ["no-bust", "coach-notes"],
    refresh: true,
    ttl: "2 hours",
  },
  async ({ api, locals }, date, athlete, athCoach, type) => {
    let user = athlete;
    if (!user) {
      user = locals.activeUser._id;
    }

    let coach = athCoach;
    if (!coach) {
      coach = locals.activeUser._id;
    }

    const res = await api("coach-note", {
      query: {
        user,
        coach,
        date,
        type: type || "calendar",
      },
    });

    return await res.json();
  }
);

register(
  {
    name: "workoutCoachNotes",
    meta: ["no-bust", "coach-notes"],
    refresh: true,
    ttl: "2 hours",
  },
  async ({ api, locals }, user, coach, dateFrom, dateTo) => {
    const res = await api("coach-notes", {
      query: {
        user,
        coach,
        dateFrom,
        dateTo,
      },
    });

    return await res.json();
  }
);
